let initState = {}

let cloneDeep = (data) => {
  //copy一份数据
  return JSON.parse(JSON.stringify(data))
}
const state = cloneDeep(initState)
const mutations = {}
const actions = {
  judgmentIsJuYunMove(card) {
    const { proType } = card
    return proType == '2-mobile_card'
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
